module.exports = __webpack_public_path__ + "media/images/shared/icon_multiply-f2283620b716393e8da598d0bd2bb4b5.png";